export default {
  placeholders: {
    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail',
    mobile_number: 'Handynummer',
  },
  labels: {
    exclusive_offers_via_email: 'Ich möchte exklusive Angebote und Neuigkeiten per E-Mail erhalten.',
  },
  buttons: {
    sign_up: 'Registrieren',
  },
};
